<template>
  <form-item label-width="80" labelAlign="left" label="列宽">
    <el-input-number v-model="temData.columnWidth"/>
  </form-item>
</template>
<script setup>
let props = defineProps({
  option: {},
  temData: {},
  compType: {},
  item: {},
});
</script>

<style scoped lang="scss"></style>
